import {inject, injectable} from 'inversify';

import type {MetricApiModel} from '../../../../../../api/metrics/types';
import type {ApiListResponse} from '../../../../../../api/types';
import type {BNUserMetricsListParams} from '../../../../../../api/types/bnrks/methods';
import type {CoreUserMetricsListParams} from '../../../../../../api/types/core/methods';

import {apiRequest} from '../../../../../../api/utils/apiRequest';
import {MetricMapperJrpc} from '../../../../../../core/domain/Metric/mappers/Metric.mapper.jrpc';
import {FetchMetricsQuery} from '../FetchMetrics.query';

@injectable()
export class FetchMetricsQueryJrpc implements FetchMetricsQuery {
  constructor(
    @inject(MetricMapperJrpc)
    private readonly mapper: MetricMapperJrpc,
  ) {}

  async exec({
    endDate,
    startDate,
  }: FetchMetricsQuery.Props): Promise<FetchMetricsQuery.Response> {
    const {_items}: ApiListResponse<MetricApiModel> = await apiRequest<
      BNUserMetricsListParams | CoreUserMetricsListParams
    >({
      method: 'user.metrics.list',
      params: {
        query: [
          ['date', '>=', startDate.toDateObj()],
          ['date', '<=', endDate.toDateObj()],
        ],
      },
    });

    return _items.map(metric => this.mapper.mapDataToModel(metric));
  }
}
